import React from "react";
import { Link } from "react-router-dom";

const BalanceMoneyCreateTransferSuccess: React.FC = () => {
    return (
        <div className="card border-success mb-3">
            <div className="card-body text-success">
                <h5 className="card-title">Transfer Created</h5>
                <p className="card-text">
                    Your transfer will go under manual review, then funds will
                    be automatically added to your account. (In manual review
                    because we are still in Beta).
                </p>
                <Link
                    className="btn btn-outline-success"
                    to="/home/dashboard/balance/money/view-transfers"
                >
                    View All Transfers
                </Link>
            </div>
        </div>
    );
};

export default BalanceMoneyCreateTransferSuccess;
